import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import {getTaxonsRep} from "../Repository/TaxonRepository";
import {RequestError} from "../Entity/RequestError";
import {AppThunk} from "../../app/store";
import {Taxon} from "../Entity/Taxon";

interface TaxonState {
  isRequesting: boolean,
  isRequestSuccess: boolean,
  isRequestFailed: boolean,
  error: RequestError | null,
  taxons: Taxon[]|null,
}

const TaxonsInitialState: TaxonState = {
  isRequesting: false,
  isRequestSuccess: false,
  isRequestFailed: false,
  taxons: null,
  error: null,
}

function startRequest(state: TaxonState) {
  state.isRequesting = true;
  state.isRequestFailed = false;
  state.taxons = null;
}

function registerFailed(state: TaxonState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function registerSuccess(state: TaxonState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.taxons = action.payload["hydra:member"] as Taxon[];
  state.error = null;
  document.dispatchEvent(new Event("onDatatablesDataReceived"));
}

const taxonSlice = createSlice({
    name: 'taxons',
    initialState: TaxonsInitialState,
    reducers: {
      taxonsStartRequest: startRequest,
      taxonSuccess: registerSuccess,
      taxonFailed: registerFailed,
    }
  }
)

export const {
  taxonsStartRequest,
  taxonSuccess,
  taxonFailed,
} = taxonSlice.actions;

export default taxonSlice.reducer;

export const getTaxons = (locale:string, taxonomyParent?:string): AppThunk => async dispatch => {
  try {
    dispatch(taxonsStartRequest());
    const newsApiResponse = await getTaxonsRep(locale, taxonomyParent);
    dispatch(taxonSuccess(newsApiResponse));
  } catch (err) {
    dispatch(taxonFailed(err));
  }
}
